import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { CDialog } from "@appcues/component-library";
import authClient from "authClient";
import { showToast } from "actions/toaster";
import { reportError } from "helpers/error-reporting";

export class ConfirmResetPasswordModal extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      hideModal: PropTypes.func.isRequired,
      showToast: PropTypes.func.isRequired
    }).isRequired
  };

  onClickResetPassword = () => {
    const {
      email,
      actions: { showToast, hideModal }
    } = this.props;
    return authClient
      .resetPassword(email)
      .then(() => {
        showToast({ message: "Password reset email sent." });
        hideModal();
      })
      .catch(err => {
        reportError(err);
        showToast({ message: "Password reset email could not be sent." });
      });
  };

  render() {
    const { actions } = this.props;

    const dialogProps = {
      type: "primary",
      title: "Confirm reset password",
      primaryActionText: "Reset password",
      onSecondaryAction: actions.hideModal,
      onPrimaryAction: this.onClickResetPassword
    };

    return (
      <CDialog {...dialogProps}>
        We'll send you an email with instructions on how to reset your password.
      </CDialog>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: {
    ...ownProps.actions,
    ...bindActionCreators(
      {
        showToast
      },
      dispatch
    )
  }
});

export default connect(null, mapDispatchToProps)(ConfirmResetPasswordModal);
